import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'getAlternativeIndividualEmails'

export default (campaignId) => (asyncAction(
  name,
  ExtraCampaignsService.getAlternativeIndividualEmails,
  { campaignId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/getAlternativeIndividualEmails.js